import { Injectable } from '@angular/core';
import { MetricsService } from './metrics.service';

@Injectable({
    providedIn: 'root'
})
export class ConsoleMetricsService implements MetricsService {

    constructor() { }

    capture(eventName: string, payload: unknown): void {
        console.log(eventName, payload);
    }

    exception(payload: unknown): void {
        console.error(payload);
    }
    reset(): void {
        throw new Error('Method not implemented.');
    }

}
